import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Zap, Trophy } from 'lucide-react';
export function UpsellSection() {
  return <section className="py-20 px-4 bg-slate-950 text-center" data-id="element-300">
      <div className="max-w-2xl mx-auto" data-id="element-301">
        <FadeIn data-id="element-302">
          <Zap className="w-10 h-10 text-amber-500 mx-auto mb-8" strokeWidth={2} data-id="element-303" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-304">
            MOMENTO — ANTES DE CONFIRMAR TU COMPRA
          </h2>
          <p className="text-xl text-amber-500 italic mb-12" data-id="element-305">
            Agregá esto a tu pack y completá el sistema en un solo paso
          </p>
        </FadeIn>

        <div className="text-left space-y-6 text-lg text-slate-300" data-id="element-306">
          <FadeIn delay={0.1} data-id="element-307">
            <p className="text-center text-slate-400" data-id="element-308">
              El Método de los 6 Tomos te transforma físicamente.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-309">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white text-center leading-tight py-4" data-id="element-310">
              Pero, ¿quién transforma tu rendimiento en el pelotón?
            </h3>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-311">
            <p data-id="element-312">Entrenás más que antes.</p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-313">
            <p data-id="element-314">Mejoraste tu resistencia.</p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-315">
            <p data-id="element-316">
              Y sin embargo... en las salidas grupales seguís sin saber
              exactamente qué hacer cuando el pelotón pica, cuando el viento
              cambia de dirección o cuando hay que gestionar una subida de 20
              minutos.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-317">
            <p className="text-white font-bold" data-id="element-318">¿Por qué?</p>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-319">
            <p data-id="element-320">
              Porque mejorar la condición física y dominar la inteligencia
              táctica del pelotón son dos cosas distintas. Y la mayoría de los
              ciclistas solo trabaja en una.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.8} data-id="element-321">
          <div className="mt-16 bg-slate-900 border-2 border-amber-500/40 rounded-2xl p-8 md:p-10 text-center relative shadow-[0_0_30px_rgba(245,158,11,0.08)]" data-id="element-322">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-500 text-slate-950 font-black px-6 py-2 rounded-full text-sm tracking-widest uppercase flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-323">
              <Trophy size={16} data-id="element-324" /> COMPLETÁ TU PACK CON:
            </div>

            <div className="mt-6 mb-10" data-id="element-325">
              <h4 className="text-4xl md:text-5xl font-serif font-bold text-white mb-2 tracking-tight" data-id="element-326">
                PELOTÓN 10X
              </h4>
              <p className="text-amber-500 font-bold uppercase tracking-wider text-sm italic" data-id="element-327">
                Master de Táctica, Viento y Rendimiento Grupal
              </p>
              <p className="text-slate-400 text-sm mt-1 italic" data-id="element-328">
                Para el Ciclista Amateur Argentino
              </p>
            </div>

            <div className="bg-slate-900/50 rounded-2xl p-6 md:p-8 text-left border border-slate-800" data-id="element-329">
              <ul className="space-y-6" data-id="element-330">
                {[{
                title: 'Sistema de posicionamiento',
                desc: 'Dónde estar en el pelotón según el terreno y el viento'
              }, {
                title: 'Mapa de tácticas de subida',
                desc: 'Qué hacer en cada tipo de subida para llegar arriba con el grupo'
              }, {
                title: 'Protocolo de rotación',
                desc: 'Cómo participar del pelotón sin destruirte ni chupar rueda todo el tiempo'
              }, {
                title: 'Gestión del viento',
                desc: 'El abanico, el echelon y las tácticas para las rutas pampeanas, cordobesas y patagónicas'
              }, {
                title: 'Mentalidad de competidor',
                desc: 'Los 5 principios mentales que separan al ciclista que mejora del que se estanca'
              }].map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-331">
                    <div className="flex-shrink-0 mt-1 text-green-500 font-bold text-lg" data-id="element-332">
                      ✓
                    </div>
                    <div className="text-slate-300 text-base md:text-lg leading-relaxed" data-id="element-333">
                      <strong className="text-white font-bold" data-id="element-334">
                        {item.title}
                      </strong>{' '}
                      <span className="text-slate-400" data-id="element-335">—</span> {item.desc}
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}